import {
  type HeaderFooterContext,
  HeaderFooterContextDocument,
} from 'src/App/generated/graphql-types';

export const rawHirerAccountInfo: HeaderFooterContext = {
  identityContext: {
    email: 'email@gmail.com',
    act: null,
  },
  advertiser: {
    hasMultipleAccounts: true,
    name: 'SEEK Test Account',
    billingId: '12345',
    isActivationPending: false,
    isAgency: false,
    permissionOptions: {
      canCreateJobs: false,
      canManageBrand: false,
      canManageUsers: false,
      canPayInvoices: false,
      canViewInvoiceHistory: false,
      canViewManagerReports: false,
      canManageCompanyProfile: false,
      canViewInsightsRoleReport: false,
      canExportApplications: { result: false },
      canClaimCompanyProfile: false,
      canViewPremiumTalentSearch: false,
    },
    showOnCreditHoldMessage: false,
    switchAccountsHref: '/oauth/integration/?#/?fn=loginWithScope', // null when single account
  },
  user: {
    __typename: 'UserHeaderContext',
    name: 'Lord Mockington',
    firstName: 'Lord',
    id: '123456',
  },
};

export const headerFooterMock = {
  request: {
    query: HeaderFooterContextDocument,
    variables: {
      input: {
        location: {
          search: '',
          pathname: '/',
        },
      },
    },
  },
  result: {
    data: {
      headerFooterContext: {
        ...rawHirerAccountInfo,
      },
      currentAdvertiser: {
        __typename: 'CurrentAdvertiserContext',
        seekId: '12345678',
      },
    },
  },
};

export const headerFooterErrorMock = {
  request: {
    query: HeaderFooterContextDocument,
    variables: {
      input: {
        location: {
          search: '',
          pathname: '/',
        },
      },
    },
  },
  error: new Error('Retrieval error'),
};

export const headerFooterNoDataMock = {
  request: {
    query: HeaderFooterContextDocument,
    variables: {
      input: {
        location: {
          search: '',
          pathname: '/',
        },
      },
    },
  },
  result: {
    data: {
      headerFooterContext: {
        user: null,
        advertiser: null,
        identityContext: null,
      },
      currentAdvertiser: null,
    },
  },
};

export const headerFooterLoadingMock = {
  request: {
    query: HeaderFooterContextDocument,
    variables: {
      input: {
        location: {
          search: '',
          pathname: '/',
        },
      },
    },
  },
  result: {
    data: {
      headerFooterContext: {
        user: null,
        advertiser: null,
        identityContext: null,
      },
      currentAdvertiser: null,
    },
    loading: true,
  },
};
